<template>
    <div class="modal-conainerr">
        <ParkingModal :visible="isModalVisible" :parking="selectedParking" @close="isModalVisible = false"
            @proceed="proceedToPayment" 
            @apply-monthly-rental="applyMonthlyRental"
            />

        <ParkingPaymentModal :visible="isPaymentModalVisible" :parking="selectedParking"
            @close="isPaymentModalVisible = false" @goOnlinePayment="goToOnlinePayment"
            @cardDiscount="goToCardDiscount" />
    </div>
</template>

<script>
import emitter from '@/emitter.js'
import { globalParams } from '@/global'

import ParkingModal from './ParkingModal.vue'
import ParkingPaymentModal from './ParkingPaymentModal.vue'

export default {
    name: 'PModal',
    components: {
        ParkingModal,
        ParkingPaymentModal
    },
    data() {
        return {
            isModalVisible: false,
            isPaymentModalVisible: false,
            selectedParking: null
        }
    },
    mounted() {
        emitter.on('open-modal', payload => {
            console.log('emiiter payload', payload)
            if (payload.name === 'PModal') {
                console.log('setting visible to true')
                // console.log 
                this.selectedParking = globalParams.selectedParking;
                this.isModalVisible = true
            }
        })
    },
    methods: {
        showModal(parking) {
            globalParams.selectedParking = parking;
            this.selectedParking = parking;
            this.isModalVisible = true;
        },

        proceedToPayment() {
            this.isModalVisible = false;
            this.isPaymentModalVisible = true;

        },
        goToOnlinePayment() {
            // const paymentUrl = this.selectedParking.payment_url;
            let paymentUrl = 'https://webpay.fortune88.com.tw/PayFromCloud'
            // if (this.selectedParking.parking_id) {
            //     paymentUrl += `?parking_id=${this.selectedParking.parking_id}`
            // }
            window.open(paymentUrl, '_blank').focus();
        },
        goToCardDiscount() {
            globalParams.prevRoute = '/OnlinePayment';
            this.$router.push('/ParkPay');
            this.isPaymentModalVisible = false;

        },
        applyMonthlyRental() {
            // this.$emit('monthlyRental');
            //goto UserApply page
            this.isModalVisible = false;
            this.isPaymentModalVisible = false;
            this.$router.push({ name: 'UserApply', params: { parking_id: this.selectedParking.id } });
        }
    }
}
</script>

<style scoped>
.modall-conainerr {
    transform: scale(0.7);
    transform-origin: center;
}
/* .modal-conainerr {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
} */

</style>